import { render, staticRenderFns } from "./thematicAreaAdvisor.vue?vue&type=template&id=28bf5656"
import script from "./thematicAreaAdvisor.vue?vue&type=script&lang=js"
export * from "./thematicAreaAdvisor.vue?vue&type=script&lang=js"
import style0 from "./thematicAreaAdvisor.vue?vue&type=style&index=0&id=28bf5656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports